import { render, staticRenderFns } from "./PlaceNotice.vue?vue&type=template&id=4821aa23"
import script from "./PlaceNotice.vue?vue&type=script&lang=js"
export * from "./PlaceNotice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports